import type { VipLevelDef } from "../schema/vip.js";

const THRESHOLDS = [
  100, 300, 800, 1_500, 3_000, 5_000, 8_000, 12_000, 18_000, 27_000, 40_000, 58_000, 82_000, 115_000, 160_000, 220_000,
  300_000, 400_000, 530_000, 700_000,
];

/** Unlock keys per VIP level (60-store.md R55). */
export const VIP_BENEFITS: Record<number, string[]> = {
  1: ["daily_chest"],
  2: ["vip_shop"],
  3: ["collect_all"],
  4: ["bookmarks.30"],
  5: ["free_featured_weekly"],
  6: ["queue.build.2"],
  7: ["arena.attempts.+2"],
  8: ["presets.5", "unit:unit.medic_prime"],
  9: ["layouts.5"],
  10: ["queue.research.2", "stamina.cap.+20"],
  11: ["march.speed.+10"],
  12: ["queue.build.3", "unit:unit.aurora_node"],
  13: ["repair.slots.+1"],
  14: ["name.gold"],
  15: ["gather.speed.+15"],
  16: ["skin:commander_vip16"],
  17: ["fabrication.discount.10"],
  18: ["unit:unit.halo_mother"],
  19: ["chest.gold.daily"],
  20: ["skin:base_custom", "megavip"],
};

export const VIP_LEVELS: readonly VipLevelDef[] = THRESHOLDS.map((points, i) => ({
  level: i + 1,
  points,
  productionPct: 2 * (i + 1),
  buildSpeedPct: i + 1,
  unlocks: VIP_BENEFITS[i + 1] ?? [],
}));

export const VIP_MAX_LEVEL = 20;

/** Additional points needed to go from MegaVIP rank n−1 to rank n (rank 1 starts after VIP 20). */
export function megaVipPointsForRank(rank: number): number {
  if (rank < 1) throw new RangeError("rank starts at 1");
  return 150_000 * Math.pow(1.1, rank - 1);
}

/** VIP points for a daily login with the given consecutive-day streak (100 + 20 per streak day, max 200). */
export function vipPointsForDailyLogin(streakDays: number): number {
  return 100 + 20 * Math.min(Math.max(streakDays - 1, 0), 5);
}
